import {useEffect} from 'react'

function Timer({ dispatch, secondsRemaining }) {

    const mins = Math.floor(secondsRemaining / 60);
    const seconds = secondsRemaining % 60;

    useEffect(function() { 
        const id = setInterval(function () {
            dispatch({ type: 'tick' });

        }, 1000); // 1000ms = 1s

        return () => clearInterval(id); // cleanup function

    }, [dispatch])

    return (
        <div className="timer">
            {mins < 10 ? '0' + mins : mins}:{seconds < 10 ? '0' + seconds : seconds}
        </div>
    )
}

export default Timer
